import axios from 'axios';

import { appStore as store } from '../index';

import { decrementBlockCounter, incrementBlockCounter, unBlockUi } from '../actions/actionCreator';
import AuthInterceptor from '../utils/AuthInterceptor';

var taxonomyHostClient = axios.create({
  headers: {
    'Cache-Control': 'public, max-age=3600, no-transform'
  }
});
taxonomyHostClient.defaults.headers.post['Content-Type'] = 'application/json';
taxonomyHostClient.defaults.headers.put['Content-Type'] = 'application/json';
taxonomyHostClient.defaults.timeout = 300000;

// Add a EAPI request interceptor
const ejecttaxonomyHostRequestInterceptorRef = taxonomyHostClient.interceptors.request.use(function (config) {
  // busting cache
  //CacheBuster.bust(config);

  //let setCurrentLang = store.getState().lang.currentLang
  //CacheBuster.taxonomyLang({...config,...setCurrentLang});

  // attaching auth token
  AuthInterceptor.attachToken(config);

  //configuring blocker
  if (config.noBlocking === undefined || config.noBlocking === false) {
    store.dispatch(incrementBlockCounter());
  }
  return config;
}, function (error) {
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});

// Add a EAPI response interceptor
const ejecttaxonomyHostResponseInterceptorRef = taxonomyHostClient.interceptors.response.use(function (response) {
  if (response.config.noBlocking === undefined || response.config.noBlocking === false) {
    store.dispatch(decrementBlockCounter());
  }
  return response;
}, function (error) {
  store.dispatch(unBlockUi());
  return Promise.reject(error);
});


// const bustCache = (url) => `${url}?cacheBuster=${new Date().getTime()}`;

export { ejecttaxonomyHostRequestInterceptorRef, ejecttaxonomyHostResponseInterceptorRef, taxonomyHostClient };




// WEBPACK FOOTER //
// ./src/restClient/taxonomyHostRestClient.js